// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c2ccf361","769":"ffb2bbfc"}[chunkId] + ".chunk.js";
};